// DO NOT EDIT THIS FILE!
// This file is autogenerated by the Parcel web application bundler.

import './app';
import '../../blocks/expandable-list/scripts/view';
import '../../blocks/grid/scripts/view';
import '../../blocks/two-block-grid/scripts/view';
import '../../blocks/hero/scripts/view';
import '../../blocks/hero-slideshow/scripts/view';
import '../../blocks/image/scripts/view';
import '../../blocks/image-carousel/scripts/view';
import '../../blocks/job-presentation/scripts/view';
import '../../blocks/login-form/scripts/view';
import '../../blocks/reset-password-form/scripts/view';
import '../../blocks/press-post-presentation/scripts/view';
import '../../blocks/latest-posts/scripts/view';
import '../../blocks/map/scripts/view';
import '../../blocks/post-archive/scripts/view';
import '../../blocks/read-more-button/scripts/view';
import '../../blocks/rich-text/scripts/view';
import '../../blocks/share/scripts/view';
import '../../blocks/tab-menu/scripts/view';
import '../../blocks/video/scripts/view';
import '../../blocks/form/scripts/view';
import '../../blocks/product-header/scripts/view';
import '../../blocks/product-files/scripts/view';
import '../../blocks/set-password-form/scripts/view';
import '../../blocks/password-message-bar/scripts/view';
import '../../blocks/three-column-grid/scripts/view';
import '../../blocks/hero-alternative/scripts/view';
import '../../blocks/selected-posts/scripts/view';
